import config from "../../assets/js/conf/config";
import { request } from "../../assets/js/utils/request";


//社区客服
export function getCommunityData(data) {
  return request(config.baseApi + "/community/lists", "post", data)
}

//首页
export function getIndexData(data) {
  return request(config.baseApi + "/home/index", "post", data)
}

// 首页文章详情
export function getDetailsData(data) {
  return request(config.baseApi + "/home/details", "post", data)
}

